import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { Children, cloneElement } from 'react';
import { useThemeValue } from '../system';
import StackView from '../StackView';

function PageBody(_ref) {
  var children = _ref.children,
      inset = _ref.inset,
      sidebar = _ref.sidebar,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "inset", "sidebar"]);

  var themeProps = useThemeValue('pageBody');
  var childrenToRender = sidebar ? Children.toArray([/*#__PURE__*/cloneElement(sidebar, {
    basis: 28
  }), /*#__PURE__*/React.createElement(StackView, {
    grow: 1,
    padding: 3,
    shrink: 1
  }, children)]) : children;
  return /*#__PURE__*/React.createElement(StackView, _extends({
    padding: sidebar && !inset ? 0 : 3,
    backgroundColor: "backgroundSecondary",
    mediaQueries: {
      md: {
        axis: sidebar && !inset ? 'horizontal' : undefined
      }
    }
  }, themeProps, restProps), inset ? /*#__PURE__*/React.createElement(StackView, {
    borderColor: "separatorSecondary",
    borderWidth: 1,
    mediaQueries: {
      md: {
        axis: sidebar ? 'horizontal' : undefined
      }
    },
    padding: sidebar ? null : 3,
    radius: 3,
    shrink: 1
  }, childrenToRender) : childrenToRender);
}

export default PageBody;